'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesDiff = datesDiff;

var _difference_in_days = require('date-fns/difference_in_days');

var _difference_in_days2 = _interopRequireDefault(_difference_in_days);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function datesDiff(date1, date2) {
  if (!date1 || !date2) {
    throw new Error('[' + [date1, date2].filter(function (date) {
      return date;
    }).join(', ') + '] invalid Date');
  }

  return (0, _difference_in_days2.default)(new Date(date2), new Date(date1));
}